import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ButtonMeta} from './buttonMeta';

@Component({
  selector: 'app-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.css']
})
export class ButtonsComponent implements OnInit {

  /**
   * Meta info of the buttons.
   */
  @Input() buttons: ButtonMeta[];
  /**
   * Is target selected.
   */
  @Input() targetSelected: boolean;
  /**
   * Listener for buttons clicks.
   */
  @Output() buttonPressed: EventEmitter<string> = new EventEmitter<string>();


  constructor() {
  }

  ngOnInit() {
  }

  /**
   * When the button has been pressed.
   * @param buttonId The id of the pressed button.
   */
  buttonPressingOccured(buttonId: string): void {
    this.buttonPressed.emit(buttonId);
  }

  /**
   * Return whether the button is disabled.
   * @param button The button whose disable state is requested.
   */
  isDisabled(button: ButtonMeta): boolean {
    return button.disableWhenNoSelection && !this.targetSelected;
  }

  /**
   * Returns a style information for button type.
   * @param buttonType Button style information.
   */
  private getButtonStyle(button: ButtonMeta): string {

    const buttonType: string = button.type;
    if (buttonType === 'edit') {
      return 'btn btn-primary';
    } else if (buttonType === 'save') {
      return 'btn btn-success';
    } else if (buttonType === 'delete') {
      return 'btn btn-danger';
    } else if (buttonType === 'general') {
      return 'btn btn-primary';
    } else {
      return '';
    }
  }
}
